import { ReactElement } from "react";
import styles from "./styles.module.css";

type Props = {
  nome: string; 
  cnpj: string;
  email: string;
  telefone: string;
  cep: string;
  cidade: string;
  estado: string;
  bairro: string;
  rua: string;
  numero: number;
  complemento: string;
  status: string;
  observacao:  string;
  children: ReactElement | ReactElement[];
};

const RowInstituicoes = ({
  nome,
  cnpj,
  email,
  telefone,
  cep,
  cidade,
  estado,
  bairro,
  rua,
  numero,
  complemento,
  status,
  observacao,
  children,
}: Props) => {

const selecionaCor = (situacao: string) => {
  switch (situacao) {
    case "aprovada":
      return styles.aprovado;
    case "pendente":
      return styles.pendente;
    case "reprovada":
      return styles.rejeitado;
  }
};
  
  return (
    <tr className={styles.row}>
      <td>{nome}</td>
      <td className={styles.sexto}>{cnpj}</td>
      <td className={styles.sexto}>{email}</td>
      <td className={styles.sexto}>{telefone}</td>
      <td className={styles.sexto}>
        <strong>Endereço:</strong> {rua}, {bairro}, {numero}<br />
        {complemento}
        {cidade} - {estado} - {cep}
      </td>
      <td className={selecionaCor(status)}>{status}</td>
      <td className={styles.btncoll}>{children}</td>
    </tr>
  );
};
export default RowInstituicoes;
